import React from 'react';
import './testimonial.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import SwiperCore, { Navigation, Autoplay} from 'swiper';
import TestiBlock from './TestiBlock';

SwiperCore.use([Navigation, Autoplay]);

function Testimonial() {

    const testimonials = [
         {
            id:1,
            name:"Ashwin",
            designation: "CEO",
            img: process.env.PUBLIC_URL + '/image/testimonials/ashwin.jpg',
            description:"Ashish is an excellent web developer as he is hard working and dedicated to his job, even he has the best knowledge of colour schemes. His work is quite appreciable, one can easily trust on him and his work anyday.",
        },
        {
            id:2,
            name:"Sajid Shaikh",
            designation: "Developer",
            img: process.env.PUBLIC_URL + '/image/testimonials/sajid.jpg',
            description:"Ashish has shown steadfast commitment to his work always. He has always been patient, consistent and great at what he does.",
        },
        {
            id:3,
            name:"Naved Shaikh",
            designation: "Developer",
            img: process.env.PUBLIC_URL + '/image/testimonials/naved.jpg',
            description:"Ashish had worked as a Web developer on one of our projects. We started with only a rough idea in the mind yet the quality of the work delivered was fabulous and far more than what was expected.",
        }
    ]
    
    return (
        <div className="testimonials">
            <div className="container">
                <h1 className="title">Testimonials</h1>
                <h2 className="subtitle">Client's Say</h2>


                <Swiper
                    spaceBetween={20}
                    slidesPerView={3}
                    navigation
                    loop={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false
                    }}
                    breakpoints={{
                        320: {
                        slidesPerView: 1,
                        },
                        500: {
                        slidesPerView: 1,
                        },
                        640: {
                        slidesPerView: 2,
                        },
                        768: {
                        slidesPerView: 2,
                        },
                        1200: {
                        slidesPerView: 3,
                        }
                    }}
                    >

                        {testimonials.map(testimonial =>(
                           <SwiperSlide key={testimonial.id}>
                               <TestiBlock content={testimonial}/>
                           </SwiperSlide>
                        ))}
                </Swiper>
                   
            </div> 


            {/* *******   Animation start  ********* */}

            <img src={process.env.PUBLIC_URL + '/image/icons/dot-line.png'} className="dot" alt="Ashish Gupta"/>  
            <img src={process.env.PUBLIC_URL + '/image/icons/dot-line.png'} className="dot dot2 " alt="Ashish Gupta"/>    

        </div>
    )
}

export default Testimonial
